import { inject, InjectionToken } from "@angular/core";
import { SidenavItemInterface } from "@app/shared-core/components/side-nav/interfaces/side-nav-items.interface";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";

export const sideNavConfig: SidenavItemInterface[] = [
  {
    id: "home",
    items: [],
    icon: "home",
    tooltip: "SIDE_NAV.HOME.TITLE",
    direction: "TOP",
    routerLink: "/",
    routerLinkExact: true,
  },
  {
    id: "scm",
    items: [
      {
        id: "scm-subjects-list",
        label: "SCM.ITEMS.SUBJECTS",
        icon: "users",
        tooltip: "SIDE_NAV.SCM.ITEMS.SUBJECTS",
        routerLink: "/scm/subjects",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-notes",
        label: "SCM.ITEMS.NOTES",
        icon: "closed-book",
        tooltip: "SIDE_NAV.SCM.ITEMS.NOTES",
        routerLink: "/scm/notes",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-pratiche",
        label: "SCM.ITEMS.PRATICHE",
        icon: "file",
        tooltip: "SIDE_NAV.SCM.ITEMS.PRATICHE",
        routerLink: "/scm/practices",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-kpi-dashboard",
        label: "SCM.ITEMS.KPI_DASHBOARD",
        icon: "chart-bar",
        tooltip: "SIDE_NAV.SCM.ITEMS.KPI_DASHBOARD",
        routerLink: "/scm/kpi-dashboard",
        direction: "TOP",
        items: [],
      },
    ],
    label: "SCM.TITLE",
    icon: "briefcase",
    tooltip: "SIDE_NAV.SCM.TITLE",
    direction: "TOP",
  },
  {
    id: "setting",
    items: [
      {
        id: "scm-subject-types",
        label: "SCM.ITEMS.SUBJECT_TYPES",
        icon: "tag",
        tooltip: "SIDE_NAV.SCM.ITEMS.SUBJECT_TYPES",
        routerLink: "/scm/settings/subject-types",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-subject-statuses",
        label: "SCM.ITEMS.SUBJECT_STATUSES",
        icon: "verified",
        tooltip: "SIDE_NAV.SCM.ITEMS.SUBJECT_STATUSES",
        routerLink: "/scm/settings/subject-statuses",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-mailing-lists",
        label: "SCM.ITEMS.MAILING_LISTS",
        icon: "mail",
        tooltip: "SIDE_NAV.SCM.ITEMS.MAILING_LISTS",
        routerLink: "/scm/settings/mailing-lists",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-email-templates",
        label: "SCM.ITEMS.EMAIL_TEMPLATES",
        icon: "template",
        tooltip: "SIDE_NAV.SCM.ITEMS.EMAIL_TEMPLATES",
        routerLink: "/scm/settings/email-templates",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-settori-merceologici",
        label: "SCM.ITEMS.SETTORI_MERCEOLOGICI",
        icon: "tag",
        tooltip: "SIDE_NAV.SCM.ITEMS.SETTORI_MERCEOLOGICI",
        routerLink: "/scm/settings/settori-merceologici",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-pratica-statuses",
        label: "SCM.ITEMS.PRATICA_STATUSES",
        icon: "verified",
        tooltip: "SIDE_NAV.SCM.ITEMS.PRATICA_STATUSES",
        routerLink: "/scm/settings/practice-statuses",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-spvs",
        label: "SCM.ITEMS.SPVS",
        icon: "tag",
        tooltip: "SIDE_NAV.SCM.ITEMS.SPVS",
        routerLink: "/scm/settings/spvs",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-activities",
        label: "SCM.ITEMS.ACTIVITIES",
        icon: "tag",
        tooltip: "SIDE_NAV.SCM.ITEMS.ACTIVITIES",
        direction: "TOP",
        items: [
          {
            id: "scm-subject-activities",
            label: "SCM.ITEMS.SUBJECT_ACTIVITIES",
            icon: "tag",
            tooltip: "SIDE_NAV.SCM.ITEMS.SUBJECT_ACTIVITIES",
            routerLink: "/scm/settings/subject-activities",
            direction: "TOP",
            items: [],
          },
          {
            id: "scm-practice-activities",
            label: "SCM.ITEMS.PRACTICE_ACTIVITIES",
            icon: "tag",
            tooltip: "SIDE_NAV.SCM.ITEMS.PRACTICE_ACTIVITIES",
            routerLink: "/scm/settings/practice-activities",
            direction: "TOP",
            items: [],
          },
        ],
      },
    ],
    label: "SETTINGS.TITLE",
    icon: "settings",
    tooltip: "SIDE_NAV.SETTINGS.TITLE",
    direction: "BTN",
  },
  {
    id: "admin",
    items: [
      {
        id: "admin-users",
        label: "ADMIN.ITEMS.USERS",
        icon: "users",
        tooltip: "SIDE_NAV.ADMIN.ITEMS.USERS",
        routerLink: "/admin/users",
        direction: "TOP",
        items: [],
      },
      {
        id: "admin-roles",
        label: "ADMIN.ITEMS.ROLES",
        icon: "shield",
        tooltip: "SIDE_NAV.ADMIN.ITEMS.ROLES",
        routerLink: "/admin/roles",
        direction: "TOP",
        items: [],
      },
      {
        id: "admin-security",
        label: "ADMIN.ITEMS.SECURITY",
        icon: "lock",
        tooltip: "SIDE_NAV.ADMIN.ITEMS.SECURITY",
        routerLink: "/admin/settings/security",
        direction: "TOP",
        items: [],
      },
      {
        id: "scm-note-settings",
        label: "SCM.ITEMS.NOTE_SETTINGS",
        icon: "closed-book",
        tooltip: "SIDE_NAV.SCM.ITEMS.NOTE_SETTINGS",
        routerLink: "/scm/notes/settings",
        direction: "TOP",
        items: [],
      },
    ],
    label: "ADMIN.TITLE",
    icon: "shield",
    tooltip: "SIDE_NAV.ADMIN.TITLE",
    direction: "BTN",
  },
];

export const ADD_MAIN_LINKS = new InjectionToken("ADD_MAIN_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.setMainLinks(sideNavConfig);
  },
});
